import { z } from "zod";
import { TEAM_ROLES } from "./roles";

export const createTeamSchema = z.object({
  name: z.string().trim().min(1).max(80),
});

export const inviteSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
  role: z.enum(TEAM_ROLES).default("editor"),
});

export const memberRoleSchema = z.object({ role: z.enum(TEAM_ROLES) });

export const shareNoteSchema = z.object({
  shares: z
    .array(z.object({ userId: z.string().uuid(), role: z.enum(TEAM_ROLES) }))
    .max(50),
});

export const commentSchema = z.object({
  body: z.string().trim().min(1).max(4000),
  anchor: z.record(z.unknown()).nullish(),
});

/** Invites are valid for a week. */
export const INVITE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export function slugify(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40) || "team"
  );
}
